module.exports = __webpack_public_path__ + "img/submit_notmember_screenshot_MAGAZINE.aee57175.png";